import axios from "axios";
import * as d3 from "d3";
import {axisTextDim1, colonAnnotation, responsivefy, XaxisAttribute} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //  var tmpVar = chart.tempVar
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    chart.height = chart.vizSpecific2 * (chart.height)
    console.log("Chart vizName called:", vizName)
    axios.post(url, filterParam).then(res => {
        let data = res.data

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width + 3 * chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + 3 * chart.margin.left + ',' + chart.margin.top + ')');

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            // create a tooltip
            var y1tip = tooltip_class()
            y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{
                    return d.dim1_name+ colonAnnotation+ numberFormat(Math.abs(d.metric1))
                })
            svg.call(y1tip);*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');

        // set the ranges
        var x1Scale = d3.scaleLinear().range([0, chart.width]);
        var y1Scale = d3.scaleBand().range([chart.height, 0]).padding(0.1);
        var metric1ColorScale = d3.scaleLinear().domain([d3.min(data, (d) => {
            return d.metric1
        }), 0]).range(["#ef3b2c", "#fee0d2"])
        var metric2ColorScale = d3.scaleLinear().domain([d3.min(data, (d) => {
            return d.metric1
        }), d3.max(data, (d) => {
            return d.metric1
        })]).range(["#f7fbff", "#2171b5"])

        function displayTextWidth(text, font) {
            let canvas = displayTextWidth.canvas || (displayTextWidth.canvas = document.createElement("canvas"));
            let context = canvas.getContext("2d");
            context.font = font;
            let metrics = context.measureText(text);
            return metrics.width;
        }

        console.log("Text Width: " + displayTextWidth("This is demo text!", "italic 19pt verdana")); //

        // Scale the range of the data in the domains
        x1Scale.domain(d3.extent(data, (d) => {
            return (Math.abs(d.metric1) > 0 && Math.abs(d.metric1) < 5) ? d.metric1 * 10 : d.metric1
        }));
        y1Scale.domain(data.map((d) => {
            return d.dim1_name;
        }));

        // append the rectangles for the bar chart
        svg.selectAll(".bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("fill", (d) => {
                return d.metric1 < 0 ? metric1ColorScale(d.metric1) : metric2ColorScale(d.metric1);
            })
            .attr("x", (d) => {
                return x1Scale(Math.min(0, d.metric1))
            })
            .attr("y", (d) => {
                return y1Scale(d.dim1_name)
            })
            .attr("width", (d) => {
                return Math.abs(x1Scale(d.metric1) - x1Scale(0))
            })
            .attr("height", y1Scale.bandwidth())
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.dim1_name + colonAnnotation + Math.abs(d.metric1).toFixed(2))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide);

        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append("text")
            .attr("class", ".bar")
            .text(function (d) {
                return Math.abs(d.metric1).toFixed(2)
            })
            .attr("y", (d) => {
                return y1Scale(d.dim1_name) + y1Scale.bandwidth() / 2 + 10
            })
            .attr("x", (d) => {
                return (d.metric1 < 0) && (displayTextWidth(d.metric1) <= Math.abs(x1Scale(d.metric1) - x1Scale(0)))
                    ? (x1Scale(d.metric1)) + 10
                    : (d.metric1 < 0) && (displayTextWidth(d.metric1) > Math.abs(x1Scale(d.metric1) - x1Scale(0)))
                        ? (x1Scale(d.metric1)) - 45
                        : (d.metric1 > 0) && (displayTextWidth(d.metric1) <= Math.abs(x1Scale(d.metric1) - x1Scale(0)))
                            ? (x1Scale(d.metric1)) - 40
                            : (d.metric1 > 0) && (displayTextWidth(d.metric1) > Math.abs(x1Scale(d.metric1) - x1Scale(0)))
                                ? (x1Scale(d.metric1)) + 10
                                : 0
            })
            .style("fill", "black")
            .style("font-size", ((chart.axisLabelFontSize - 5) + "px"));

        // add the x Axis
        svg.append("g")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(d3.axisBottom(x1Scale).tickFormat(""))
            .style('font-size', axisLabelFontSize);

        // add the y Axis
        svg.append("g")
            .attr("class", "y axis")
            // .attr("transform", "translate(" + x1Scale(d3.min(data,(d) =>{ return d.metric1})) + ",0)")
            .call(d3.axisLeft(y1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height - chart.margin.bottom + 4 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left - 4 * chart.axisLabelDistance + 20)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        var sumstat = d3.nest().key(d => {
            return d.dim2_name
        }).sortKeys(d3.descending).entries(data)

        var y1legend = svg.append('g')
            .attr('font-family', 'sans-serif').selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', function (d, i) {
                var horz = 180 * i;
                var vert = 6;
                return 'translate(' + horz + ',' + vert + ')';
            });

        y1legend.append('rect')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height - chart.margin.bottom + 3 * chart.axisLabelDistance - 10)
            .attr('width', 15)
            .attr('height', 15)
            .attr('fill', (d) => {
                return d.key == chart.vizSpecific5 ? "#2171b5" : "#FF0000"
            })

        y1legend.append('text')
            .data(sumstat, d => {
                return d.key
            })
            .attr('x', (chart.width / 3) + 25)
            .attr('y', chart.height - chart.margin.bottom + 3 * chart.axisLabelDistance + 5)
            .attr('fill', 'black')
            .text(d => {
                return d.key
            })
            .style('font-size', axisLabelFontSize)
    });
}
